import * as React from 'react'
import styled from 'styled-components'
import { Size, Color } from '../../../constants/app.constant'
import Logo from '-!react-svg-loader!./images/logo.svg'
import Menu from '-!react-svg-loader!./images/etc.svg'
import { useDispatch } from 'redux-react-hook'
import { signOut } from '../../../actions/auth.action'
import history from '../../utils/history'
import '../../../css/style.css'

const showBalloon = () => {
  const menuShare = document.getElementById('menuShare')
  if (menuShare.className === 'balloonShareNone') {
    menuShare.className = 'balloonShare'
  } else {
    menuShare.className = 'balloonShareNone'
  }
  /*
  const menuInquiry = document.getElementById('menuInquiry')
  if (menuInquiry.className === 'balloonInquiryNone') {
    menuInquiry.className = 'balloonInquiry'
  } else {
    menuInquiry.className = 'balloonInquiryNone'
  }
  */
  const menuPasswordChange = document.getElementById('menuPasswordChange')
  if (menuPasswordChange.className === 'balloonPasswordChangeNone') {
    menuPasswordChange.className = 'balloonPasswordChange'
  } else {
    menuPasswordChange.className = 'balloonPasswordChangeNone'
  }
  const menuLogout = document.getElementById('menuLogout')
  if (menuLogout.className === 'balloon1') {
    menuLogout.className = 'balloon'
  } else {
    menuLogout.className = 'balloon1'
  }
}

export default () => {
  const dispatch = useDispatch()
  return (
    <Wrapper>
      <Link>
        <Logo href="/" />
        <div className="menu" onClick={showBalloon}>
          <div className="logout">
            <Menu />
            <input
              type="button"
              value="運動履歴"
              id="menuShare"
              className="balloonShareNone"
              onClick={() => history.push('/report')}
            />
            {/*
            <input
              type="button"
              value="お問い合わせ"
              id="menuInquiry"
              className="balloonInquiryNone"
              onClick={() => history.push('/inquiry')}
            />
            */}
            <input
              type="button"
              value="パスワード変更"
              id="menuPasswordChange"
              className="balloonPasswordChangeNone"
              onClick={() => history.push('/password_change')}
            />
            <input
              type="button"
              value="ログアウト"
              id="menuLogout"
              className="balloon1"
              onClick={() => dispatch(signOut())}
            />
          </div>
        </div>
      </Link>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  font-size: ${Size.FONT.XLARGE}px;
  text-align: center;
  width: 100%;
  padding: 4px 0;
  margin-left: -50px;
  border-bottom: 1px solid ${Color.PALETTE_COLOR.VERY_LIGHT_GRAY_2};
  & svg {
    overflow: visible;
    width: 100px;
  }
`
const Link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/molecules/header/header.tsx